module.exports = __webpack_public_path__ + "static/img/diploma.e071eed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/diploma.png
// module id = NVm1
// module chunks = 1